import http from "./http.service";
import Promisable from "./promisable.service";
import { modalActions } from "redux/slices/modal";
import { QuotationType } from "redux/slices/quotation";
import { NavigateFunction } from "react-router-dom";
import { getAppDispatch } from "utils/dispatch.util";
import { quotationActions } from "redux/slices/quotation";
import { formLoaderActions } from "redux/slices/formLoader";
import { reset } from "redux-form";

const url = "/quotation";

const QuotationService = {
  addQuotation: async (data: any, navigate?: NavigateFunction) => {
    const dispatch = getAppDispatch();
    dispatch?.(formLoaderActions.setLoading(true));
    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}`, data)
    );

    if (success) {
      const { quotation } = success.data.data;
      dispatch?.(
        quotationActions.newQuotation({ type: "open", quotation: quotation })
      );
      navigate?.(`/rfqs`);
      dispatch?.(reset("AddQuotationForm"));
    }
    dispatch?.(formLoaderActions.setLoading(false));

    return [success, error];
  },

  updateQuotation: async (
    id: string,
    data: any,
    navigate?: NavigateFunction
  ) => {
    const dispatch = getAppDispatch();
    dispatch?.(formLoaderActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/update/${id}`, data)
    );

    if (success) {
      const { quotation } = success.data.data;
      dispatch?.(quotationActions.updateQuotation({ id, type: quotation.status, quotation }));
      navigate?.(`/rfqs`);
    }

    dispatch?.(formLoaderActions.setLoading(false));
    return [success, error];
  },
  deleteQuotation: async (id: string, type: "open" | "close") => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.delete(`${url}/${id}`)
    );
    if (success) {
      dispatch?.(quotationActions.removeQuotation({ id, type }));
    }
    dispatch?.(modalActions.setLoading(false));
    dispatch?.(modalActions.closeModal());

    return [success, error];
  },

  updateStatus: async (id: string, type: "open" | "close") => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.patch(`${url}/${id}`, { type })
    );
    if (success) {
      const { quotation } = success.data.data;
      dispatch?.(
        quotationActions.removeQuotation({
          id,
          type: type == "open" ? "close" : "open",
        })
      );
      dispatch?.(quotationActions.newQuotation({ type, quotation }));
    }
    dispatch?.(modalActions.setLoading(false));
    dispatch?.(modalActions.closeModal());

    return [success, error];
  },

  getQuotation: async (id: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(quotationActions.setLoader(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/${id}`)
    );

    if (success) {
      const { quotation } = success.data.data;
      dispatch?.(quotationActions.setQuotation(quotation));
    } else dispatch?.(quotationActions.setQuotation({ data: null }));

    dispatch?.(quotationActions.setLoader(false));
    return [success, error];
  },

  getQuotations: async (type: QuotationType, data: any) => {
    const dispatch = getAppDispatch();

    dispatch?.(quotationActions.setLoading({ type, loading: true }));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/list/${type}`, data)
    );

    if (success) {
      const { quotations, count } = success.data.data;

      dispatch?.(
        quotationActions.setQuotations({ type, count, quotations: quotations })
      );
    }

    if (data?.all) dispatch?.(modalActions.setLoading(false));
    else dispatch?.(quotationActions.setLoading({ type, loading: false }));

    return [success, error];
  },
};

export default QuotationService;
